import { render, staticRenderFns } from "./sourceImport.vue?vue&type=template&id=38881292"
import script from "./sourceImport.vue?vue&type=script&lang=js"
export * from "./sourceImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports